import { render, staticRenderFns } from "./DeliveryLocationPanel.vue?vue&type=template&id=0b166572&"
import script from "./DeliveryLocationPanel.vue?vue&type=script&lang=js&"
export * from "./DeliveryLocationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports